function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendarChangeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.55 5h-3V3h-2v2h-12V3h-2v2h-3a2 2 0 00-2 2v7h26V7a2 2 0 00-2-2zm0 7h-22V7h3v3h2V7h12v3h2V7h3v5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.043 27H4.55V16h-2v11a2 2 0 002 2h8.493v-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.55 20v-2h-4v2h4zM11.55 22v2h-4v-2h4zM15.98 20v-2h-2.427v2h2.428z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1 23.177a2.924 2.924 0 00-.005.237c0 2.575 1.98 4.586 4.316 4.586a4.172 4.172 0 002.839-1.134l.004-.005.085-.077 1.35 1.475-.082.075A6.172 6.172 0 0122.411 30c-3.535 0-6.316-3.002-6.316-6.586v-.013c0-.098 1.051.887 1.065.736l.94-.96z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.58 21.324l3.929 2.673-1.125 1.654-2.224-1.514-1.446 2.269-1.687-1.075 2.554-4.007zM22.552 19.209a4.172 4.172 0 00-2.839 1.135l-.004.004-.085.077-1.35-1.474.082-.076a6.172 6.172 0 014.196-1.666c3.535 0 6.316 3.002 6.316 6.586v.013c0 .099 0 .248-.013.4l-1.992-.176c.004-.056.005-.122.005-.237 0-2.575-1.98-4.586-4.316-4.586z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.683 26.09l-4.079-2.438 1.027-1.716 2.309 1.38 1.31-2.35 1.747.974-2.314 4.15z",
    fill: props.color
  }));
}

export default SvgIconCalendarChangeFilled;